<template>
  <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">

      <Form @submit="editProduitRestreint">
        <div class="row">

          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Type de restriction <span class="text-danger">*</span>
              </label>
              <Multiselect :options="restrictionTypeOptions" :searchable="true" track-by="value" label="label"
                v-model="formData.restriction_type" value-prop="value" :object="true" placeholder="Sélectionner le type de restriction" />
              <ErrorMessage name="restriction_type" class="text-danger" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Pays <span class="text-danger">*</span>
              </label>
              <Multiselect :options="paysOptions" :searchable="true" track-by="value" label="label" :object="true"
                v-model="formData.pays" placeholder="Sélectionner le pays" />
            </div>
            <ErrorMessage name="pays" class="text-danger" />
          </div>

          <div class="col-md-12">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Description <span class="text-danger">*</span>
              </label>
              <Field 
                name="description" 
                as="textarea" 
                rows="2"
                class="form-control shadow-none fs-md-15 text-black"
                v-model="formData.description"
                placeholder="Description..." 
              />
              <ErrorMessage name="description" class="text-danger" />
            </div>
          </div>
          
          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Type de document
              </label>
              <Multiselect :options="typeDOptions" :searchable="true" :object="true" track-by="value" label="label"
                v-model="formData.typeD" placeholder="Sélectionner le type de document" />
            </div>
            <ErrorMessage name="typeD" class="text-danger" />
          </div>

          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Hs Code
              </label>
              <Multiselect :options="hscodeOptions" :searchable="true" track-by="value" label="label" :object="true"
                v-model="formData.hscode" placeholder="Sélectionner le hscode" />
            </div>
            <ErrorMessage name="hscode" class="text-danger" />
          </div>

          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Catégorie Produit
              </label>
              <Multiselect :options="categorieProduitOptions" :searchable="true" track-by="value" label="label"
                v-model="formData.categorieProduit" :object="true" placeholder="Sélectionner la categorie de Produit" />
            </div>
            <ErrorMessage name="categorieProduit" class="text-danger" />
          </div>
          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Régime Douanier
              </label>
              <Multiselect :options="regimeDouanierOptions" :searchable="true" track-by="value" label="label"
                v-model="formData.regimeDouanier" :object="true" placeholder="Sélectionner le régime" />
            </div>
            <ErrorMessage name="regimeDouanier" class="text-danger" />
          </div>

          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">Quantité maximale</label>
              <Field name="max_quantity" type="number" class="form-control" v-model="formData.max_quantity" placeholder="Quantité maximale autorisée" />
              <ErrorMessage name="max_quantity" class="text-danger" />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">Valeur maximale</label>
              <Field name="max_declared_value" type="number" class="form-control" v-model="formData.max_declared_value"
                placeholder="Valeur maximale autorisée" />
              <ErrorMessage name="max_declared_value" class="text-danger" />
            </div>
          </div>
          
          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Date de début d'application de cette restriction.
              </label>
              <Field name="effective_from" type="date" v-model="formData.effective_from"
                class="form-control shadow-none fs-md-15 text-black" />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Date de fin d'application éventuelle
              </label>
              <Field name="effective_to" v-model="formData.effective_to" type="date"
                class="form-control shadow-none fs-md-15 text-black" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">Activer</label>
              <Field name="is_active" type="checkbox" class="form-check-input" v-model="formData.is_active" :value="true" :unchecked-value="false" />
              <ErrorMessage name="is_active" class="text-danger" />
            </div>
          </div>

          <div class="col-md-12">
            <div class="d-flex align-items-center ">
              <button type="submit"
                class="default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success">
                Modifier le produit
              </button>
              <router-link to="/listeProduitRestreint" class="btn btn-danger transition border-0 lh-1 fw-medium">
                <i class="flaticon-delete lh-1 me-1 position-relative top-2"></i>
                <span class="position-relative"></span>Annuler
              </router-link>
            </div>
          </div>
        </div>
      </Form>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, computed, reactive } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import { error, success } from '@/utils/utils';
import { useRoute, useRouter } from 'vue-router';
import ApiService from '@/services/ApiService';
import * as Yup from 'yup';
import Multiselect from '@vueform/multiselect';

export default defineComponent({
  name: "EditProduitRestreint",
  components: {
    Form,
    Field,
    ErrorMessage,
    Multiselect
  },

  setup() {
    const route = useRoute();
    const router = useRouter();
    const productId = route.params.id;
    
    interface Option {
      value: string;
      label: string;
    }
    
    const paysOptions = ref<Option[]>([]);
    const hscodeOptions = ref<Option[]>([]);
    const categorieProduitOptions = ref<Option[]>([]);
    const regimeDouanierOptions = ref<Option[]>([]);
    const typeDOptions = ref<Option[]>([]);

    const restrictionTypeOptions = [
      { value: 'FORBIDDEN', label: 'Interdit' },
      { value: 'LICENSE_REQUIRED', label: 'Licence requise' },
      { value: 'SPECIAL_TAX', label: 'Taxe spéciale' },
      { value: 'QUOTA_LIMITED', label: 'Quantité limitée' },
    ];

    const formData = reactive({
      description: '',
      effective_from: '',
      effective_to: '',
      restriction_type: null as { value: string; label: string } | null,
      pays: null as { value: string; label: string } | null,
      hscode: null as { value: string; label: string } | null,
      categorieProduit: null as { value: string; label: string } | null,
      regimeDouanier: null as { value: string; label: string } | null,
      typeD: null as { value: string; label: string } | null,
      max_quantity: null as number | null,
      max_declared_value: null as number | null,
      is_active: false,
    });

    const fetchTypeDocument = async () => {
      const { data } = await ApiService.get('/typeDocumentBescs');
      typeDOptions.value = data.data.data.map((t: any) => ({
        value: t.id,
        label: `${t.code} - ${t.libelle}`,
      }));
    };

    const fetchRegimeDouanier = async () => {
      const { data } = await ApiService.get('/regimes');
      regimeDouanierOptions.value = data.data.data.map((r: any) => ({
        value: r.id,
        label: `${r.code} - ${r.name}`,
      }));
    };

    const fetchCatProduit = async () => {
      const { data } = await ApiService.get('/categProduits');
      categorieProduitOptions.value = data.data.data.map((c: any) => ({
        value: c.id,
        label: `${c.code} - ${c.name}`,
      }));
    };

    const fetchHscode = async () => {
      const { data } = await ApiService.get('/hscodes');
      hscodeOptions.value = data.data.data.map((h: any) => ({
        value: h.id,
        label: `${h.code} - ${h.product}`,
      }));
    };

    const fetchPays = async () => {
      const { data } = await ApiService.get('/pays');
      paysOptions.value = data.data.data.map((p: any) => ({
        value: p.id,
        label: p.name_fr,
      }));
    };

    const formatDate = (dateString: string | null): string => {
      if (!dateString) return '';
      return dateString.split('T')[0];
    };

    const getProduit = async (id: string) => {
      try {
        const response = await ApiService.get(`/restricted/${id}`);
        const product = response.data.data;
        console.log("getproduct0", response.data.data)
        
        formData.description = product.description || '';
        formData.restriction_type = restrictionTypeOptions.find(opt => opt.value === product.restriction_type) || null;
        formData.effective_from = formatDate(product.effective_from);
        formData.effective_to = formatDate(product.effective_to);
        formData.max_quantity = product.max_quantity || null;
        formData.max_declared_value = product.max_declared_value || null;
        formData.is_active = product.is_active || false;
        
        formData.pays = product.pays ? {
          value: product.pays.id,
          label: `${product.pays.name_fr}`
        } : null;
        
        formData.hscode = product.hscode ? {
          value: product.hscode.id,
          label: `${product.hscode.code} ${product.hscode.product}`
        } : null;
        
        formData.categorieProduit = product.categorieProduit ? {
          value: product.categorieProduit.id,
          label: `${product.categorieProduit.code} ${product.categorieProduit.name}`
        } : null;
        
        formData.regimeDouanier = product.regimedouanier ? {
          value: product.regimedouanier.id,
          label: `${product.regimedouanier.code} ${product.regimedouanier.name}`
        } : null;

        formData.typeD = product.typeD ? {
          value: product.typeD.id,
          label: `${product.typeD.code} ${product.typeD.libelle}`
        } : null;
      } catch (err) {
        error("Impossible de charger le produit restreint");
      }
    };

    const editProduitRestreint = async () => {
      try {

        const toNumber = (val: any) => (val === "" || val === undefined || val === null) 
      ? null 
      : Number(val);

    const payload = {
        description: formData.description,
        restriction_type: formData.restriction_type?.value,
        effective_from: formData.effective_from || null,
        effective_to: formData.effective_to || null,
        pays: formData.pays ? formData.pays.value : null,
        typeD: formData.typeD ? formData.typeD.value : null,
        regimeDouanier: formData.regimeDouanier ? formData.regimeDouanier.value : null,
        hscode: formData.hscode ? formData.hscode.value : null,
        categorieProduit: formData.categorieProduit ? formData.categorieProduit.value : null,
        max_quantity: toNumber(formData.max_quantity),     
        max_declared_value: toNumber(formData.max_declared_value),  
            is_active: formData.is_active,
        }
        console.log("payload envoyé", payload);
        await ApiService.put(`/restricted/${productId}`, payload);
        success("Produit restreint modifié avec succès");
        router.push({ name: "ListeProduitRestreintPage" });
      } catch (err: any) {
        error(err.response?.data?.message || "Erreur lors de la modification");
      }
    };

    onMounted(async () => {
      fetchPays();
      fetchTypeDocument();
      fetchRegimeDouanier();
      fetchCatProduit();
      fetchHscode();

      if (productId) await getProduit(productId as string);
    });

    return {
      formData,
      editProduitRestreint,
      hscodeOptions,
      categorieProduitOptions,
      regimeDouanierOptions,
      typeDOptions,
      paysOptions,
      restrictionTypeOptions
    };
  },
});
</script>
